/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'overview': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<defs><path pid="0" d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z" id="a"/></defs><g _fill="none" fill-rule="evenodd"><use _fill="#000" fill-rule="nonzero" xlink:href="#a"/></g>'
  }
})
